import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { SpinnerServices } from "src/app/core/services/spinner.service";

@Injectable()
export class SpinnerInteceptor implements HttpInterceptor {
    constructor(private spinnerSvc: SpinnerServices) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let blnSpin = true;
        let body;
        if (req.body != null) {    
            if (typeof req.body === 'object') {
                body = req.body;
            } else if(typeof req.body === 'string'){
                body = JSON.parse(req.body);
            }

            if (body.spinner != null) {
                blnSpin = false;
            }
        }

        if(blnSpin){
            this.spinnerSvc.show();
        }

        return next.handle(req).pipe(
            finalize(() => this.spinnerSvc.hide()));
    }

}